/* Shipping Protection claim form. Posts to the EM Shipping Protection app proxy (/apps/em-protection/claims).
   Pure checks are exported for tests; the DOM part runs only in the browser. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    root.ShippingProtectionClaim = api;
    if (typeof document !== 'undefined') {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { api.initAll(document); });
      else api.initAll(document);
    }
  }
})(typeof self !== 'undefined' ? self : this, function () {
  var MAX_PHOTOS = 5;
  var MAX_PHOTO_BYTES = 10 * 1024 * 1024;

  var ALL_ISSUES = ['lost', 'damaged', 'wrong_item'];
  // Issues that need a photo, from the app setting; unset/unreadable = all of them.
  function requiredIssues(list) {
    if (!Array.isArray(list)) return ALL_ISSUES.slice();
    return ALL_ISSUES.filter(function (i) { return list.indexOf(i) !== -1; });
  }

  function photoError(files, required) {
    if ((!files || files.length === 0) && required !== false) return 'Add at least one photo of the package, the damage, or where it should have been delivered.';
    if (files.length > MAX_PHOTOS) return 'Add up to 5 photos.';
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      if (!/^image\//.test(f.type || '')) return f.name + " isn't a photo. Use JPG, PNG, WEBP or HEIC.";
      if (f.size > MAX_PHOTO_BYTES) return f.name + ' is over 10MB. Try a smaller photo.';
    }
    return null;
  }

  function parseList(raw) {
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function fieldErrors(response) {
    return (response && response.errors) || {};
  }

  function init(form) {
    var wrap = form.closest('[data-sp-claim]');
    var summary = wrap.querySelector('[data-sp-claim-error]');
    var success = wrap.querySelector('[data-sp-claim-success]');
    var submit = form.querySelector('[type="submit"]');
    var photos = form.querySelector('input[name="photos"]');
    form.noValidate = true; // we show our own messages; without JS the browser validates natively
    var needs = requiredIssues(parseList(wrap.getAttribute('data-sp-photos-required')));
    var optionalMark = form.querySelector('[data-sp-photos-optional]');
    function photosRequired() {
      var picked = form.querySelector('input[name="issue"]:checked');
      return picked ? needs.indexOf(picked.value) !== -1 : true;
    }
    function syncPhotoLabel() {
      photos.required = photosRequired();
      if (optionalMark) optionalMark.hidden = photos.required;
    }
    form.addEventListener('change', function (e) { if (e.target && e.target.name === 'issue') syncPhotoLabel(); });
    syncPhotoLabel();

    function setFieldError(name, message) {
      var el = form.querySelector('[data-error-for="' + name + '"]');
      var input = form.querySelector('[name="' + name + '"]');
      if (el) { el.textContent = message || ''; el.hidden = !message; }
      if (input && input.type !== 'radio') input.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (name === 'issue') {
        var set = form.querySelector('fieldset');
        if (set) set.setAttribute('aria-invalid', message ? 'true' : 'false');
      }
    }
    function clearErrors() {
      ['orderNumber', 'email', 'issue', 'details', 'photos'].forEach(function (n) { setFieldError(n, ''); });
      summary.hidden = true;
      summary.textContent = '';
    }
    function showSummary(message) {
      summary.textContent = message;
      summary.hidden = false;
      summary.focus();
    }

    photos.addEventListener('change', function () {
      setFieldError('photos', photoError(photos.files, photosRequired()) || '');
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearErrors();
      var err = photoError(photos.files, photosRequired());
      if (err) { setFieldError('photos', err); photos.focus(); return; }
      if (!form.checkValidity()) { form.reportValidity(); return; }

      submit.disabled = true;
      form.setAttribute('aria-busy', 'true');
      submit.dataset.label = submit.dataset.label || submit.textContent;
      submit.textContent = 'Sending…';

      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json().catch(function () { return { ok: false }; }); })
        .then(function (data) {
          if (data && data.ok) {
            form.hidden = true;
            success.querySelector('[data-sp-claim-ref]').textContent = data.ref;
            success.hidden = false;
            success.focus();
            return;
          }
          var errors = fieldErrors(data);
          var names = Object.keys(errors);
          names.forEach(function (n) { setFieldError(n, errors[n]); });
          showSummary((data && data.error) || (names.length ? 'Please fix the highlighted fields.' : 'Something went wrong. Please try again or email us.'));
        })
        .catch(function () { showSummary('We couldn\'t send your claim. Check your connection and try again.'); })
        .then(function () {
          submit.disabled = false;
          form.removeAttribute('aria-busy');
          submit.textContent = submit.dataset.label;
        });
    });
  }

  function initAll(doc) {
    var forms = doc.querySelectorAll('[data-sp-claim] form');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  return { MAX_PHOTOS: MAX_PHOTOS, MAX_PHOTO_BYTES: MAX_PHOTO_BYTES, photoError: photoError, requiredIssues: requiredIssues, fieldErrors: fieldErrors, initAll: initAll };
});
